<template>
  <div :v-bind="getShipment">
    <v-list two-line
            v-for="(shipment) in shipments"
            :key="shipment.id">
      <v-list-tile ripple
                   @click="toggle(shipment.id)">
        <v-list-tile-content>
          <v-list-tile-title class="blue--text darken-4">
            <span v-for="(msg, key, index) in shipment.newMessages"
                  :key="index">
              <v-icon class="red--text darken-4"
                      v-if="id === key && msg === true">fiber_new</v-icon>
            </span>
            <span v-for="(selected, key) in shipment.isSelected"
                  :key="key">
              <v-icon class="blue--text darken-4"
                      v-if="id === key && selected === true">check_circle</v-icon>
            </span>
            {{shipment.Delivery[shipment.Delivery.length - 1]}}
          </v-list-tile-title>

          <v-list-tile-sub-title class="orange--text darken-4">
            {{shipment.PickupDate}}
          </v-list-tile-sub-title>

          <v-list-tile-action-text class="teal--text darken-4">
            <broker-name :brokerID="shipment.Shipper"></broker-name>
            - {{shipment.Reference}}
          </v-list-tile-action-text>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
    </v-list>

    <v-layout row
              wrap
              v-if="!Object.keys(shipments).length">
      <v-flex>
        <v-card>
          <v-card-text class="blue--text darken-4">
            No Completed Shipments available.
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
import Firebase from 'firebase'
import db from './fireBaseInit'
import brokerName from '@/components/BrokerName'

export default {
  name: 'FreightSearch',
  props: ['id', 'isBroker'],
  components: { brokerName },
  data () {
    return {
      shipments: {}
    }
  },
  methods: {
    toggle (shipmentID) {
      this.$emit('cargo', shipmentID)
    }
  },
  computed: {
    getShipment: function () {
      if (this.isBroker) {
        console.log('broker')
        this.$bind('shipments', db.collection('freight')
          .where(`brokers.${Firebase.auth().currentUser.uid}`, '==', true)
          .where('isActive', '==', false)).then((doc) => { return true })
      } else {
        console.log('shipper')
        this.$bind('shipments', db.collection('freight')
          .orderBy('PickupDate', 'desc')
          .where('Shipper', '==', Firebase.auth().currentUser.uid)
          .where('isActive', '==', false)).then((doc) => { return true })
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/FreightSearch.vue